export { default as speed } from './speed.svg';
export { default as privacy } from './privacy.svg';
export { default as security } from './security.svg';
export { default as ecosystem } from './ecosystem.svg';
export { default as internet } from './internet.svg';



// WEBPACK FOOTER //
// ./src/components/Skywire/images/index.js